import React from "react";
import ReactDOM from "react-dom";
import axios from 'axios';
import { useSearchParams } from "react-router-dom";

//import naturalSort from "javascript-natural-sort";
import ReactPaginate from 'react-paginate';

import moment from "moment";

import withRouter from '../libs/withRouter.jsx';
import withAuth from "../libs/withAuth.jsx";
import copyTextToClipboard from "../libs/copyTextToClipboard.jsx";
import Loader from "../libs/loader.jsx";


import { Button, Heading, Link, Tooltip, Table, TableHeader, TableHeaderCell, TableBody, TableVirtualizedBody, TableRow, TableCell, Flex, Divider, Search, ButtonGroup, Dropdown, MenuButton, Menu, MenuItem, Text } from "monday-ui-react-core";
import { Edit, Add, Duplicate, Info, ExternalPage, Basic, Share, Delete, Versioning } from "monday-ui-react-core/dist/allIcons";

import ChangesPopup from './changes.jsx';

import Monday from "../auth/useMonday.jsx";

import historyHelper from "./helper.jsx";

import mondaySdk from "monday-sdk-js";
const monday = mondaySdk();
monday.setApiVersion(config.monday_api.version);

class DatasetList extends React.Component
{
    constructor(props)
    {
        super(props);
        var this_component = this;

        const search = Object.fromEntries(this_component.props.router.search.entries());
        
        //console.log("DatasetList props:", {props}, {...this_component.props}, search  );
        
        this_component.user = this_component.props.auth.user;
        
        if(this_component.user.is_admin == true)
        {
            this_component.tableColumns = [
                {id: 'name', loadingStateType: 'medium-text', title: 'Name', sort: null},
                {id: 'action_user_name', loadingStateType: 'medium-text', title: 'User', width: 250, sort: null},
                {id: 'owner_user_name', loadingStateType: 'medium-text', title: 'Owner', width: 250, sort: null},
                {id: 'created_at', loadingStateType: 'medium-text', title: 'Date', width: 160, sort: 'desc'},
                {id: 'action', loadingStateType: 'medium-text', title: 'Action', sort: null},
                {id: 'changes', loadingStateType: 'medium-text', title: 'Changes', sort: null},
                {id: 'url', loadingStateType: 'long-text', title: 'URL', width: 65, sort: null},
            ];
        }
        else
        {
            this_component.tableColumns = [
                {id: 'name', loadingStateType: 'medium-text', title: 'Name', sort: null},
                {id: 'action_user_name', loadingStateType: 'medium-text', title: 'User', width: 250, sort: null},
                {id: 'created_at', loadingStateType: 'medium-text', title: 'Date', width: 160, sort: 'desc'},
                {id: 'action', loadingStateType: 'medium-text', title: 'Action', sort: null},
                {id: 'changes', loadingStateType: 'medium-text', title: 'Changes', sort: null},
                {id: 'url', loadingStateType: 'long-text', title: 'URL', width: 65, sort: null},
            ];
        }
        
        this_component.tableSorting = {};
        this_component.tableColumns.map( (headerCell, index) => { this_component.tableSorting[headerCell.id] = headerCell.sort } );
        
        var sortKey = ('sortKey' in search)?search.sortKey:'created_at';
        var sortOrder = ('sortOrder' in search)?search.sortOrder:'desc';
        
        //preset sort if present in query str
        Object.keys( this_component.tableSorting ).forEach(function(key, index) {
            if( this_component.tableSorting[key] !== null) this_component.tableSorting[key] = 'none';
        });
        
        this_component.tableSorting[sortKey] = sortOrder;
        //end
        
        this.state = {
            sortKey: sortKey,
            sortOrder: sortOrder,
            items: [],
            page: 1,
            perPage: 10,
            pageCount: 1,
            isLoading: false,
            isError: false,
            searchValue: ('searchValue' in search)?search.searchValue:'',
            searchType: ('searchType' in search)?parseInt(search.searchType):1,
            searchOwnerId: ('searchOwnerId' in search)?parseInt(search.searchOwnerId):null,
            searchUserId: ('searchUserId' in search)?parseInt(search.searchUserId):null,
            
            tableColumns: this_component.tableColumns,
            tableSorting: this_component.tableSorting,
            
            ignoreDidUpdate: false,
            
            user: this_component.user,
            users: {},
            all_users_list: [],
            all_owners_users_list: [],
        };
        
        this_component.loader = React.createRef();
        
        this.tableVirtualizedBodyRender = this.tableVirtualizedBodyRender.bind(this);
        
        this_component.handleSearchValue = this_component.handleSearchValue.bind(this_component);
        this_component.handleSearchType = this_component.handleSearchType.bind(this_component);
        this_component.onTableSort = this_component.onTableSort.bind(this_component);
        
        this_component.handlePageClick = this_component.handlePageClick.bind(this_component);
        
    }
    
    async promisedSetState(newState)
    { 
        var state = this.state;
        for(let key of Object.keys(newState))
        {
            state[key] = newState[key];
        }
        
        this.state = state;
        
        var this_component = this;
        if(this.synStateTimer==false)
        {
            this.synStateTimer = setTimeout( () => { 
                this_component.setState( {...this_component.state} );
                this_component.synStateTimer = false; 
                this_component.forceUpdate();
            }, 100);
        }
        
        return true;
    }

    
    async loadUsers()
    {
        var users = await Monday.getUsers(this.loader);
        //console.log("loadUsers", users);
        await this.promisedSetState({'users': users});
    }
    
    
    async loadAllUsersList()
    {
        var this_component= this;

        var data = {};
        
        var url = '/api/v1/dataset_history/all_users_list';
        
        if(this_component.state.user.is_admin == true)
        {
            url = '/api/v1/dataset_history/admin_all_users_list';
        }

        await this_component.promisedSetState({'isLoading': true});
        this_component.forceUpdate();
        
        try
        {
            var response = await axios.get(url, { 'params': data} );
            
            var users = response.data.users;
            
            //console.log('users', users);
            await this_component.promisedSetState({'all_users_list': [...users]});
            await this_component.promisedSetState({'isLoading': false});
            
            this_component.forceUpdate();
        }
        catch( error )
        {
            console.log('datasetHistory all_users_list error', error, error.response);
            //console.error(error);
            await this_component.promisedSetState({'isLoading': false});
            await this_component.promisedSetState({'isError': true});
            this_component.forceUpdate();

            throw error;
        }
    }
    
    
    async loadAllOwnersUsersList()
    {
        var this_component= this;

        var data = {};
        
        var url = '/api/v1/dataset_history/all_owners_users_list';

        await this_component.promisedSetState({'isLoading': true});
        this_component.forceUpdate();
        
        try
        {
            var response = await axios.get(url, { 'params': data} );
            
            var users = response.data.users;
            
            //console.log('users', users);
            await this_component.promisedSetState({'all_owners_users_list': [...users]});
            await this_component.promisedSetState({'isLoading': false});
            
            this_component.forceUpdate();
        }
        catch( error )
        {
            console.log('datasetHistory all_owners_users_list error', error, error.response);
            //console.error(error);
            await this_component.promisedSetState({'isLoading': false});
            await this_component.promisedSetState({'isError': true});
            this_component.forceUpdate();

            throw error;
        }
    }
    
    
    async componentDidMount()
    {
        this.loader.current.showLoader();
        
        await this.loadUsers();
        await this.loadAllUsersList();
        
        if(this.state.user.is_admin == true)
        {
            await this.loadAllOwnersUsersList();
        }
        
        await this.refresh();
        
        this.loader.current.hideLoader();
    }
    
    
    async componentDidUpdate(prevProps, prevState)
    {
        var this_component = this;
    
        //console.log("componentDidUpdate ignoreDidUpdate", this_component.state.ignoreDidUpdate, prevState.ignoreDidUpdate );
    
        if( (prevProps.router.search.toString() !== this_component.props.router.search.toString()) )
        {
            
            if(this_component.state.ignoreDidUpdate !== true) 
            {
                const search = Object.fromEntries(this_component.props.router.search.entries());
                //console.log("search changed", search);
                
                var sortKey = ('sortKey' in search)?search.sortKey:'created_at';
                var sortOrder = ('sortOrder' in search)?search.sortOrder:'desc';
        
                await this_component.promisedSetState( {'searchValue': ('searchValue' in search)?search.searchValue:''} );
                await this_component.promisedSetState( {'searchType': ('searchType' in search)?parseInt(search.searchType):1} );
                
                if(this_component.state.user.is_admin == true)
                {
                    await this_component.promisedSetState( {'searchOwnerId': ('searchOwnerId' in search)?parseInt(search.searchOwnerId):null} );
                }
                
                await this_component.promisedSetState( {'searchUserId': ('searchUserId' in search)?parseInt(search.searchUserId):null} );
                
                await this_component.promisedSetState( {'sortKey': sortKey } );
                await this_component.promisedSetState( {'sortOrder': sortOrder } );
                
                //preset sort if present in query str
                var tableSorting = this_component.state.tableSorting;
                Object.keys( tableSorting ).forEach(function(key, index) {
                    if( tableSorting[key] !== null) tableSorting[key] = 'none';
                });

                tableSorting[sortKey] = sortOrder;

                await this_component.promisedSetState({'tableSorting': tableSorting});
                //end
                
                await this_component.refresh();
            }
            else
            {
                await this_component.promisedSetState({'ignoreDidUpdate': false});
            }
        }
        
    }

    
    async refresh()
    {
        var this_component = this;
        await this_component.fetchItems();
        /*this_component.$forceUpdate();*/
    }
    
    
    async handleSearchValue(value)
    {
        var this_component= this;
        
        await this_component.promisedSetState({'searchValue': value});
        await this_component.promisedSetState({'page': 1});
        
        await this_component.promisedSetState({'ignoreDidUpdate': true});
        const search = Object.fromEntries(this_component.props.router.search.entries());
        search.searchValue = value;
        this_component.props.router.setSearchParams(search);

        await this_component.refresh();
    }


    async handleSearchType(value)
    {
        var this_component= this;
        
        if(value !== this_component.state.searchType)
        {
            await this_component.promisedSetState({'searchType': value});
            
            
            await this_component.promisedSetState({'ignoreDidUpdate': true});
            const search = Object.fromEntries(this_component.props.router.search.entries());
            search.searchType = value;
            this_component.props.router.setSearchParams(search);
            
            await this_component.refresh();
        }
    }


    async handlePageClick(event)
    {
        var this_component= this;
        
        await this_component.promisedSetState({'page': (event.selected+1) });
        await this_component.refresh();
        
        //console.log(`User requested page number ${event.selected}`, event);
    };
    
    
    emptyState()
    {
        var this_component= this;
        
        return (<Flex className="pt-2 pb-2" justify={Flex.justify.CENTER}>
            Not Data
        </Flex>);
    }


    async onTableSort(id, sort)
    {
        var this_component= this;
        
        if(id == this_component.state.sortKey)
        {
            switch(this_component.state.sortOrder)
            {
                case 'asc': sort = 'desc'; break;
                default:
                case 'desc': 
                    sort = 'asc'; 
                break;
            }
        }
        else
        {
            sort = this_component.state.sortOrder;
        }
        
        var tableSorting = this_component.state.tableSorting;
        
        Object.keys(tableSorting).forEach(function(key, index) {
            if(tableSorting[key]!=null) tableSorting[key] = 'none';
        });
        
        tableSorting[id] = sort;
        
        await this_component.promisedSetState({'tableSorting': tableSorting});
        
        await this_component.promisedSetState({'sortKey': id});
        await this_component.promisedSetState({'sortOrder': sort});
        
        await this_component.promisedSetState({'ignoreDidUpdate': true});
        const search = Object.fromEntries(this_component.props.router.search.entries());
        search.sortKey = id;
        search.sortOrder = sort;
        this_component.props.router.setSearchParams(search);
                
        await this_component.refresh();
        
    }


    async fetchItems()
    {
        var this_component= this;

        var data = {};
        data['page'] = this_component.state.page;
        data['perPage'] = this_component.state.perPage;
        data['sortKey'] = this_component.state.sortKey;
        data['sortOrder'] = this_component.state.sortOrder;
        data['search'] = this_component.state.searchValue;
        
        if(this_component.state.searchOwnerId != null && this_component.state.user.is_admin == true) data['owner_id'] = this_component.state.searchOwnerId;
        
        if(this_component.state.searchUserId != null) data['user_id'] = this_component.state.searchUserId;
        
        var url = '/api/v1/dataset_history/list';
        
        if(this_component.state.user.is_admin == true)
        {
            url = '/api/v1/dataset_history/admin_list';
        }

        await this_component.promisedSetState({'isLoading': true});
        this_component.forceUpdate();
        
        try
        {
            var response = await axios.get(url, { 'params': data} );
            
            var items = response.data.items;
            /*
            var items = response.data.items.map( (item, index) => {
                //console.log('item', index, item);
                item.owner_user_name = '';
                if(item.owner_monday_user_id in this_component.state.users)
                {
                    item.owner_user_name = this_component.state.users[item.owner_monday_user_id].name;
                }
                item.user_name = '';
                if(item.monday_user_id in this_component.state.users)
                {
                    item.user_name = this_component.state.users[item.monday_user_id].name;
                }
                return item;
            });
            */
            
            //console.log('items', items);
            await this_component.promisedSetState({'items': [...items]});
            await this_component.promisedSetState({'pageCount': response.data.pageCount});
            await this_component.promisedSetState({'isLoading': false});
            
            if(this_component.state.isError == true)
            {
                await this_component.promisedSetState({'isError': false});
            }
            
            this_component.forceUpdate();
        }
        catch( error )
        {
            console.log('datasetHistory list error', error, error.response);
            //console.error(error);
            await this_component.promisedSetState({'isLoading': false});
            await this_component.promisedSetState({'isError': true});
            this_component.forceUpdate();
        }
    }


    getExportUrl(item)
    {
        return window.location.protocol+'//'+window.location.hostname + config.app_core_export_url + '/'+item.hash;
    }


    copy(item)
    {
        //console.log('copy',e);
        copyTextToClipboard( this.getExportUrl(item) );
    }


    getUserById(id)
    {
        var this_component = this;
        
        var user = {'id': id, 'name': 'Deleted user'};
        
        if(id in this_component.state.users)
        {
            user = {... this_component.state.users[id]};
            if(user.name == 'Deleted member' && user.enabled === false)
            {
                user.name = 'Deleted: ' + user.id;
            }
            else if(user.enabled === false) 
            {
                user.name = 'Inactive: ' + user.name;
            }
        }
        return user;
    }


    tableCellOwnerContent(item)
    {
        var this_component= this;
        
        var selected = this_component.getUserById(item.owner_monday_user_id);
        
        return selected.name;
    }


    tableCellUserContent(item)
    {
        var this_component= this;
        
        var selected = this_component.getUserById(item.monday_user_id);
        
        return selected.name;
    }
    
    async handleSearchOwner(selected)
    {
        console.log('handleSearchOwner', selected);
        var this_component= this;
        
        var value = null;
        if(selected!=null)
        {
            value = selected.value;
        }
        
        if(value !== this_component.state.searchOwnerId)
        {
            await this_component.promisedSetState({'searchOwnerId': value});
            
            
            await this_component.promisedSetState({'ignoreDidUpdate': true});
            const search = Object.fromEntries(this_component.props.router.search.entries());
            search.searchOwnerId = value;
            this_component.props.router.setSearchParams(search);
            
            await this_component.refresh();
        }
    }
    
    tableSearchOwnerContent()
    {
        var this_component= this;

        var options = [];
            
        this_component.state.all_owners_users_list.forEach(function(id, index) {
            var user = this_component.getUserById(id);

            options.push({'label': user.name,'value': parseInt(user.id)});
        });

        //console.log("options",options);
        var selected = [];
        
        if(this_component.state.searchOwnerId)
        {
            var user = this_component.getUserById(this_component.state.searchOwnerId);
            selected.push({'label': user.name,'value': parseInt(user.id)});
        }
        
        return (
            <Dropdown
                placeholder="Owner"
                options={options}
                className="dropdown"
                dropdownMenuWrapperClassName="dropdownpopupmenu"
                size={Dropdown.sizes.MEDIUM}
                value={ selected }
                clearable={true}
                autoFocus={false}
                maxMenuHeight={400}
                onChange={ (selected) => this_component.handleSearchOwner(selected) }
                menuPosition={Dropdown.menuPositions.FIXED}
            />
        );
    }
    
    
    async handleSearchUser(selected)
    {
        console.log('handleSearchUser', selected);
        var this_component= this;
        
        var value = null;
        if(selected!=null)
        {
            value = selected.value;
        }
        
        if(value !== this_component.state.searchUserId)
        {
            await this_component.promisedSetState({'searchUserId': value});
            
            
            await this_component.promisedSetState({'ignoreDidUpdate': true});
            const search = Object.fromEntries(this_component.props.router.search.entries());
            search.searchUserId = value;
            this_component.props.router.setSearchParams(search);
            
            await this_component.refresh();
        }
    }
    
    tableSearchUserContent()
    {
        var this_component= this;

        var options = [];
            
        this_component.state.all_users_list.forEach(function(id, index) {
            var user = this_component.getUserById(id);

            options.push({'label': user.name,'value': parseInt(user.id)});
        });

        //console.log("options",options);
        var selected = [];
        
        if(this_component.state.searchUserId)
        {
            var user = this_component.getUserById(this_component.state.searchUserId);
            selected.push({'label': user.name,'value': parseInt(user.id)});
        }
        
        return (
            <Dropdown
                placeholder="User"
                options={options}
                className="dropdown"
                dropdownMenuWrapperClassName="dropdownpopupmenu"
                size={Dropdown.sizes.MEDIUM}
                value={ selected }
                clearable={true}
                autoFocus={false}
                maxMenuHeight={400}
                onChange={ (selected) => this_component.handleSearchUser(selected) }
                menuPosition={Dropdown.menuPositions.FIXED}
            />
        );
    }
    
    tableCellActionContent(item)
    {
        var actions = item.action?item.action:[];
        
        actions = actions.map(function(item){
            return (item in config.texts.changes.actions)?config.texts.changes.actions[item]:item;
        });
    
        return actions.join(", ");
    }
    
    
    tableVirtualizedBodyRender(item)
    {
        //console.log("tableVirtualizedBodyRender", item);
        var this_component = this;

        var refChanges = React.createRef();
        var refChangesButton = React.createRef();
        
        return (
            <TableRow key={'tablerow'+item.id}>
                <TableCell className="tableCellFixHeight">{item.name}</TableCell>
                <TableCell className="tableCellFixHeight">{this_component.tableCellUserContent(item)}</TableCell>
                {(this_component.state.user.is_admin == true)?<TableCell className="tableCell tableCellFixHeight">{this_component.tableCellOwnerContent(item)}</TableCell>:null}
                <TableCell className="tableCellFixHeight">{moment(item.created_at).format("YYYY-MM-DD HH:mm")}</TableCell>
                <TableCell className="tableCellFixHeight">{this_component.tableCellActionContent(item)}</TableCell>
                <TableCell className="tableCellFixHeight">
                    <ChangesPopup ref={refChanges} openModalButtonRef={refChangesButton} action={item.action} data={item.change} />
                    <div className="navbar-brand-link" style={{'overflow': 'hidden'}} ref={refChangesButton} onClick={ () => refChanges.current.showModal() }>
                        <Tooltip content={<>{historyHelper.formatChanges(item.action, item.change)}</>}>
                            {/*<Text type={Text.types.TEXT2} color={Text.colors.PRIMARY}>{JSON.stringify(item.change)}</Text>*/}
                            <div className="divCollapsedText">{historyHelper.formatChangesText(item.action, item.change)}</div>
                        </Tooltip>
                    </div>
                </TableCell>
                <TableCell className="tableCellFixHeight">
                    <Tooltip content={"Copy link"} position={Tooltip.positions.BOTTOM}>
                        <Button onClick={(e) => this_component.copy(item)} type={Button.inputTags.BUTTON} kind={Button.kinds.SECONDARY} size={Button.sizes.SMALL} marginRight={true}><Duplicate /></Button>
                    </Tooltip>
                </TableCell>
            </TableRow>
        );
    }


    render()
    {
        var this_component = this;
        //console.log("List",this_component.state.items);
        
        return (
                <Loader ref={this_component.loader}>

                            <div className="divTable">
                                {/*
                                <div className="divTableRow">
                                    <Flex className="mb-2" gap={Flex.gaps.SMALL}>
                                        
                                        <Search placeholder="Search" wrapperClassName="col-4 pl-0 pr-0" debounceRate={1000} value={this_component.state.searchValue} onChange={ (value)=> this_component.handleSearchValue(value) } />
                                        
                                        <ButtonGroup
                                            size={ButtonGroup.sizes.MEDIUM}
                                            onSelect={ (value,name) => { this_component.handleSearchType(value);} }
                                            options={[
                                              {
                                                text: 'My Data Sources',
                                                value: 1,
                                              },
                                              {
                                                text: 'Shared With Me',
                                                value: 2
                                              }
                                            ]}
                                            value={this_component.state.searchType}
                                        />
                                        

                                    </Flex>
                                </div>
                                */}
                                
                                <div className="divTableRowAllHeight">
                                    <Table dataState={{ isLoading: this_component.state.isLoading, isError: this_component.state.isError }} errorState={<Flex className="mt-2 mb-2" justify={Flex.justify.CENTER}>Error on getting data</Flex>} emptyState={this_component.emptyState()} className="tableVirtualizedBody" columns={this_component.state.tableColumns} >
                                        
                                        <div className="customTableHeader">
                                            <div className="customTableHeaderCell" style={ {'paddingInlineStart': '0px'} } >
                                                <Search placeholder="Search" wrapperClassName="pl-0 pr-0" debounceRate={1000} value={this_component.state.searchValue} onChange={ (value)=> this_component.handleSearchValue(value) } />
                                            </div>
                                            <div className="customTableHeaderCell">{this_component.tableSearchUserContent()}</div>
                                            {(this_component.state.user.is_admin == true)?<div className="customTableHeaderCell">{this_component.tableSearchOwnerContent()}</div>:null}
                                            <div className="customTableHeaderCell"></div>
                                            <div className="customTableHeaderCell"></div>
                                            <div className="customTableHeaderCell"></div>
                                            <div className="customTableHeaderCell"></div>
                                        </div>
                                        
                                        <TableHeader>
                                            {this_component.state.tableColumns.map((headerCell, index) => <TableHeaderCell key={index} title={headerCell.title} onSortClicked={headerCell.sort?sortState => this_component.onTableSort(headerCell.id, sortState):null} sortState={this_component.state.tableSorting[headerCell.id]} />)}
                                        </TableHeader>

                                        <TableBody items={this_component.state.items}>
                                            {this_component.state.items.map( item => this_component.tableVirtualizedBodyRender(item) )}
                                        </TableBody>

                                    </Table>
                                    
                                    <ReactPaginate
                                        breakLabel="..."
                                        nextLabel="Next"
                                        previousLabel="Previous"
                                        
                                        onPageChange={ (event)=> this_component.handlePageClick(event) }
                                        pageRangeDisplayed={3}
                                        marginPagesDisplayed={1}
                                        pageCount={this_component.state.pageCount}
                                        forcePage={(this_component.state.page-1)}
                                        
                                        renderOnZeroPageCount={null}
                                        
                                        className="pagination justify-content-center"
                                        pageClassName="page-item navbar-brand-link"
                                        previousClassName="page-item navbar-brand-link"
                                        nextClassName="page-item navbar-brand-link"
                                        pageLinkClassName="page-link"
                                        previousLinkClassName="page-link"
                                        nextLinkClassName="page-link"
                                        activeClassName="active"
                                        
                                        breakClassName="page-item navbar-brand-link"
                                        breakLinkClassName="page-link"
                                    />
                                    
                                </div>
                            </div>
                </Loader>
        );
    }
}

DatasetList.defaultProps = {};

export default withRouter(withAuth(DatasetList));
